<div class="header">
  <h2>Kurse</h2>
</div>

<iframe [src]="iframeUrl | safe"></iframe>
